import React, { Component } from 'react'
import Layout from '../components/layout'
import './StaticPage.scss'

export default class Datenschutz extends Component {
  render () {
    const isFr = window.location.href.indexOf('fr-FR') > -1

    return (
      <Layout {...this.props} className="category">
        <div className="static-page">
          {isFr ? <DatenschutzFr /> : <DatenschutzDe />}
        </div>
      </Layout>
    )
  }
}

const DatenschutzDe = () => (
  <>
    <h1>Datenschutzbestimmungen</h1>

    <h2>1. Datenschutz auf einen Blick</h2>
    <p>Die Vögeli AG nimmt den Schutz Ihrer persönlichen Daten ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.</p>

    <h2>2. Verantwortliche Stelle</h2>
    <p>
      <strong>Vögeli AG</strong><br />
      Sägestrasse 23A<br />
      CH-3550 Langnau im Emmental<br />
      Telefon: <a href="tel:+41344091010">+41 34 409 10 10</a><br />
      E-Mail: <a href="mailto:voegeli@voegeli.ch">voegeli@voegeli.ch</a>
    </p>

    <h2>3. Erhebung und Speicherung personenbezogener Daten</h2>
    <p>Wenn Sie unseren Online-Shop nutzen, erheben wir folgende Daten, die für die Vertragsabwicklung notwendig sind:</p>
    <ul>
      <li>Anrede, Vorname, Nachname</li>
      <li>E-Mail-Adresse</li>
      <li>Rechnungs- und Lieferadresse</li>
    </ul>
    <p>Die Verarbeitung dieser Daten erfolgt auf Grundlage des Schweizer Datenschutzgesetzes (DSG), da die Verarbeitung für die Erfüllung eines Vertrags erforderlich ist.</p>

    <h2>4. Zahlungsabwicklung</h2>
    <p>Die Zahlung erfolgt über eine separate, gehostete Zahlungsseite von <strong>Worldline</strong>. Ihre Zahlungsdaten werden ausschliesslich direkt bei Worldline eingegeben und verarbeitet — sie gelangen zu keinem Zeitpunkt auf unsere Server und sind für die Vögeli AG nicht einsehbar. Es gelten die Datenschutzbestimmungen von Worldline: <a href="https://www.worldline.com/de/home/footer/privacy-policy.html" target="_blank" rel="noreferrer">www.worldline.com</a></p>

    <h2>5. Datenspeicherung</h2>
    <p>Alle Daten, die Sie in diesem Online-Shop eingeben, werden ausschliesslich auf unserem eigenen Inhouse-Server in der Schweiz gespeichert. Es findet keine Übermittlung von Shop-Daten an externe Dritte statt — mit Ausnahme der Zahlungs- und Lieferabwicklung.</p>

    <h2>6. Shop-Plattform</h2>
    <p>Dieser Online-Shop wird betrieben auf Basis von <strong>XMPie uStore</strong>, einer Software der Xerox-Gruppe, installiert und betrieben auf unserem eigenen Server. Sämtliche Benutzerkonten und Bestelldaten verbleiben auf unserer Infrastruktur.</p>

    <h2>7. Weitergabe von Daten</h2>
    <p>Personenbezogene Daten werden grundsätzlich nicht an Dritte weitergegeben. Ausnahmen bestehen ausschliesslich für:</p>
    <ul>
      <li><strong>Zahlungsabwicklung:</strong> Zahlungsinformationen werden direkt über die Worldline-Zahlungsseite verarbeitet.</li>
      <li><strong>Lieferung:</strong> Ihre Lieferadresse und Ihr Name werden an den beauftragten Versanddienstleister weitergegeben.</li>
    </ul>

    <h2>8. Ihre Rechte</h2>
    <p>Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten sowie das Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu können Sie sich jederzeit an uns wenden.</p>

    <h2>9. Cookies</h2>
    <p>Unsere Website verwendet Cookies, die für den technischen Betrieb der Website erforderlich sind. Andere Cookies werden nur mit Ihrer ausdrücklichen Zustimmung gesetzt.</p>

    <h2>10. Kontakt</h2>
    <p>Bei Fragen zum Datenschutz: <a href="mailto:voegeli@voegeli.ch">voegeli@voegeli.ch</a></p>
  </>
)

const DatenschutzFr = () => (
  <>
    <h1>Politique de confidentialité</h1>

    <h2>1. Aperçu de la protection des données</h2>
    <p>Vögeli AG prend la protection de vos données personnelles très au sérieux. Nous traitons vos données personnelles de manière confidentielle et conformément aux dispositions légales en matière de protection des données.</p>

    <h2>2. Responsable du traitement</h2>
    <p>
      <strong>Vögeli AG</strong><br />
      Sägestrasse 23A<br />
      CH-3550 Langnau im Emmental<br />
      Téléphone : <a href="tel:+41344091010">+41 34 409 10 10</a><br />
      E-mail : <a href="mailto:voegeli@voegeli.ch">voegeli@voegeli.ch</a>
    </p>

    <h2>3. Collecte et stockage des données personnelles</h2>
    <p>Lorsque vous utilisez notre boutique en ligne, nous collectons les données suivantes :</p>
    <ul>
      <li>Civilité, prénom, nom</li>
      <li>Adresse e-mail</li>
      <li>Adresse de facturation et de livraison</li>
    </ul>
    <p>Ces données sont traitées sur la base de la loi suisse sur la protection des données (LPD).</p>

    <h2>4. Traitement des paiements</h2>
    <p>Le paiement s'effectue via une page de paiement hébergée séparément par <strong>Worldline</strong>. Vos données de paiement sont saisies et traitées exclusivement directement chez Worldline — elles ne parviennent à aucun moment sur nos serveurs. Politique de confidentialité Worldline : <a href="https://www.worldline.com/fr/home/footer/privacy-policy.html" target="_blank" rel="noreferrer">www.worldline.com</a></p>

    <h2>5. Stockage des données</h2>
    <p>Toutes les données saisies dans cette boutique sont stockées exclusivement sur notre propre serveur en Suisse. Aucune donnée n'est transmise à des tiers externes, à l'exception du traitement des paiements et des livraisons.</p>

    <h2>6. Plateforme de la boutique</h2>
    <p>Cette boutique est exploitée sur la base de <strong>XMPie uStore</strong>, installé sur notre propre serveur. Tous les comptes utilisateurs et données de commandes restent sur notre infrastructure.</p>

    <h2>7. Transmission des données</h2>
    <p>Les données personnelles ne sont pas transmises à des tiers, à l'exception de :</p>
    <ul>
      <li><strong>Paiement :</strong> Via la page de paiement sécurisée Worldline.</li>
      <li><strong>Livraison :</strong> Adresse et nom transmis au prestataire de livraison.</li>
    </ul>

    <h2>8. Vos droits</h2>
    <p>Vous avez le droit d'obtenir gratuitement des informations sur vos données personnelles ainsi que le droit de rectification, de blocage ou de suppression. Contactez-nous à tout moment.</p>

    <h2>9. Cookies</h2>
    <p>Notre site utilise des cookies nécessaires au fonctionnement technique. D'autres cookies ne sont placés qu'avec votre consentement explicite.</p>

    <h2>10. Contact</h2>
    <p>Pour toute question : <a href="mailto:voegeli@voegeli.ch">voegeli@voegeli.ch</a></p>
  </>
)
